import React, { useEffect, useState } from "react";
import PagesIndex from "../../PagesIndex";
import WalletLoader from "../../../components/common/WalletLoader";
import {
  buyWithCryptoTokenAction,
  getNetworkDataAction,
} from "../../../redux/admin/action";
import { Contract, ethers } from "ethers";
import TokenAbi from "../../Connectivity/abi/tokenAbi.json";
import {
  useAppKit,
  useAppKitProvider,
  useAppKitAccount,
  useAppKitNetwork,
} from "@reown/appkit/react";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import QrGenerate from "./QrGenerate";
import { polygon, mainnet } from "@reown/appkit/networks";
export default function PurchaseToken() {
  const { userId } = PagesIndex.useParams();
  const navigate = PagesIndex.useNavigate();
  const location = PagesIndex.useLocation();
  const { open } = useAppKit();
  const { address, isConnected } = useAppKitAccount();
  const { walletProvider } = useAppKitProvider("eip155", "solana");
  const { switchNetwork } = useAppKitNetwork();
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const themeColor = new URLSearchParams(location.search).get("mode");
  const [networkData, setNetworkData] = useState([]);
  const [selectedNetwork, setSelectedNetwork] = useState(null);
  const [amount, setAmount] = useState("");
  const [tokenAmount, setTokenAmount] = useState("");
  const [conversionRate, setConversionRate] = useState("");
  const [platformFee, setPlatformFee] = useState("");
  const [sapValueInUsd, setSapValueInUsd] = useState(0);
  const [ADAPrice, setADAPriceUsd] = useState("");
  const [polygonPriceInUsd, setPolygonPriceInUsd] = useState("");
  const [solanaPriceInUsd, setSolanaPriceInUsd] = useState("");
  const [moneroPriceInUsd, setMoneroPriceInUsd] = useState("");
  const [ETHPriceinUSD, setETHPriceinUSD] = useState(0);
  const [openQrModal, setOpenQrModal] = useState(false);
  const [hashValue, setHashValue] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [tokenUSDPriceValue, setTokenUSDPriceValue] = useState(0);

  const handleAmountChange = (e) => {
    const value = e.target.value;
    if (value == "00" || value == ".") return;
    if (/^\d{0,8}(\.\d{0,4})?$/.test(value)) {
      setAmount(value);
    }
    const tokenUSDPrice =
      selectedNetwork?.networkName === "ETH"
        ? ETHPriceinUSD
        : selectedNetwork?.networkName === "POL"
        ? polygonPriceInUsd
        : selectedNetwork?.networkName === "SOL"
        ? solanaPriceInUsd
        : selectedNetwork?.networkName === "ADA"
        ? ADAPrice
        : selectedNetwork?.networkName === "XRP"
        ? moneroPriceInUsd
        : "1";
    let episapTokenValue = (
      (Number(amount)?.toFixed(6) * tokenUSDPrice) /
      sapValueInUsd
    )
      ?.toFixed(6)
      ?.replace(/\.?0+$/, "");
    setTokenAmount(episapTokenValue);
    setTokenUSDPriceValue(tokenUSDPrice);
    setConversionRate(Number(amount).toFixed(6) * tokenUSDPrice);
    setPlatformFee(
      ((Number(amount) * selectedNetwork?.platformFee) / 100 || 0)
        ?.toFixed(6)
        .replace(/\.?0+$/, "") || ""
    );
  };

  const buyToken = async () => {
    if (!isConnected) {
      alert("Please connect your wallet");
    } else if (amount == 0) {
      console.log("Please enter an amount greater than zero.");
    } else {
      setLoading(true);
      const ethersProvider = new ethers.providers.Web3Provider(walletProvider);
      const signer = ethersProvider.getSigner();
      const balance = await signer.getBalance();

      try {
        if (selectedNetwork?.networkName === "USDT") {
          const USDTAddress = "0xdAC17F958D2ee523a2206206994597C13D831ec7";
          // const USDTAddress = "0x1E848402Ed00d6e3C286983805E5Fa4bBd357627";
          const weiValue = ethers.utils.parseUnits(amount.toString(), 6);
          const USDTContract = new ethers.Contract(
            USDTAddress,
            TokenAbi,
            signer
          );
          const USDTBalance = await USDTContract.balanceOf(address);

          if (Number(USDTBalance.toString()) <= Number(weiValue.toString())) {
            setLoading(false);
            return alert("You have insufficient balance in your USDT wallet");
          }
          try {
            const transferUSDT = await USDTContract.transfer(
              selectedNetwork?.receiverAddress,
              weiValue
            );
            const receipt = await transferUSDT.wait();
            if (Number(receipt.status) === 1) {
              handleBuyToken(receipt?.transactionHash);
            } else {
              alert("Transaction failed");
            }
          } catch (error) {
            setLoading(false);
            alert("Transaction failed");
            console.log(error, "buyerror");
          }
        } else if (selectedNetwork?.networkName === "USDC") {
          const USDCAddress = "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48";
          // const USDCAddress = "0xf0F46f84bE4f4bF303801362F1F75dd18340fe02";
          const weiValue = ethers.utils.parseUnits(amount.toString(), 6);
          const USDCContract = new Contract(USDCAddress, TokenAbi, signer);
          const USDCBalance = await USDCContract.balanceOf(address);

          if (Number(USDCBalance.toString()) <= Number(weiValue.toString())) {
            console.log("You have insufficient USDC balance in you wallet");
            setLoading(false);
            return alert("You have insufficient balance in your USDC wallet");
          }
          try {
            const transferUSDC = await USDCContract.transfer(
              selectedNetwork?.receiverAddress,
              weiValue
            );
            const receipt = await transferUSDC.wait();
            if (Number(receipt.status) === 1) {
              handleBuyToken(receipt?.transactionHash);
            } else {
              setLoading(false);
              alert("Transaction failed");
            }
          } catch (error) {
            setLoading(false);
            alert("Transaction failed");
            console.log(error, "buyerror");
          }
        } else if (selectedNetwork?.networkName === "ETH") {
          const weiValue = ethers.utils.parseEther(amount.toString());
          if (balance.lt(weiValue)) {
            console.log("You have insufficient ETH balance in you wallet");
            setLoading(false);
            return alert("You have insufficient balance in your ETH wallet");
          }
          const amountInWei = ethers.utils.parseEther(amount.toString());
          const tx = await signer.sendTransaction({
            to: selectedNetwork?.receiverAddress,
            value: amountInWei,
          });
          const receipt = await tx.wait();

          if (Number(receipt.status) === 1) {
            handleBuyToken(receipt?.transactionHash);
          } else {
            setLoading(false);
            alert("Transaction failed");
          }
        } else if (selectedNetwork?.networkName === "POL") {
          const weiValue = ethers.utils.parseEther(amount.toString());
          if (balance.lt(weiValue)) {
            console.log("You have insufficient POL balance in you wallet");
            setLoading(false);
            return alert("You have insufficient balance in your POL wallet");
          }
          const amountInWei = ethers.utils.parseEther(amount.toString());
          const tx = await signer.sendTransaction({
            to: selectedNetwork?.receiverAddress,
            value: amountInWei,
          });
          const receipt = await tx.wait();

          if (Number(receipt.status) === 1) {
            handleBuyToken(receipt?.transactionHash);
          } else {
            setLoading(false);
            alert("Transaction failed");
          }
        } else if (selectedNetwork?.networkName === "ADA") {
          setOpenQrModal(true);
        } else if (selectedNetwork?.networkName === "XRP") {
          setOpenQrModal(true);
        } else if (selectedNetwork?.networkName === "SOL") {
          setOpenQrModal(true);
        }
      } catch (error) {
        setLoading(false);
        alert("Transaction failed");
        console.error("Error calling contract function:", error);
      }
    }
  };
  const getBalance = async () => {
    try {
      const response = await axios.get(
        "https://api.coingecko.com/api/v3/simple/price?ids=solana,ethereum,polygon-ecosystem-token,cardano,matic,ripple&vs_currencies=usd"
      );

      if (response?.data) {
        setADAPriceUsd(response?.data?.cardano?.usd);
        setSolanaPriceInUsd(response?.data?.solana?.usd);
        setMoneroPriceInUsd(response?.data?.ripple?.usd);
        setETHPriceinUSD(response?.data?.ethereum?.usd);
        setPolygonPriceInUsd(response?.data?.["polygon-ecosystem-token"]?.usd);
      }
    } catch (error) {
      console.log({ error });
    }
  };
  useEffect(() => {
    getBalance();
  }, []);

  const getNetworkData = async () => {
    try {
      const res = await getNetworkDataAction();
      setNetworkData(res?.cryptoNetworks);
      // setSelectedNetwork(res?.cryptoNetworks[0] || null);
      setSapValueInUsd(Number(res?.tokenPrice)?.toFixed(7));
      setIsVisible(false);
    } catch (error) {
      console.log(error, "error");
      setIsVisible(false);
    }
  };

  useEffect(() => {
    getNetworkData();
  }, []);

  const handleNetworkChange = (e) => {
    const selected = networkData?.find(
      (net) => net?.networkName === e?.target?.value
    );

    if (
      selected?.networkName === "ETH" ||
      selected?.networkName === "USDT" ||
      selected?.networkName === "USDC"
    ) {
      switchNetwork(mainnet);
    } else {
      switchNetwork(polygon);
    }
    alert("Please switch network to " + JSON.stringify(selected));
    setSelectedNetwork(selected);
  };

  useEffect(() => {
    if (selectedNetwork) {
      const tokenUSDPrice =
        selectedNetwork?.networkName === "ETH"
          ? ETHPriceinUSD
          : selectedNetwork?.networkName === "POL"
          ? polygonPriceInUsd
          : selectedNetwork?.networkName === "SOL"
          ? solanaPriceInUsd
          : selectedNetwork?.networkName === "ADA"
          ? ADAPrice
          : selectedNetwork?.networkName === "XRP"
          ? moneroPriceInUsd
          : "1";

      let episapTokenValue = (
        (Number(amount)?.toFixed(6) * tokenUSDPrice) /
        sapValueInUsd
      )
        ?.toFixed(6)
        ?.replace(/\.?0+$/, "");
      setTokenAmount(episapTokenValue);
      setTokenUSDPriceValue(tokenUSDPrice);
      setConversionRate(Number(amount)?.toFixed(6) * tokenUSDPrice);
      setPlatformFee(
        (Number(amount) * selectedNetwork?.platformFee) / 100 || ""
      );
    }
  }, [amount, selectedNetwork, networkData]);

  const handleBuyToken = async (transactionHash) => {
    alert("call")
    try {
      const res = await buyWithCryptoTokenAction({
        userId: userId,
        walletAddress: address,
        networkId: selectedNetwork?._id,
        receiverAddress: selectedNetwork?.receiverAddress,
        price: Number(amount),
        transactionType: "buyWithCrypto",
        tokenValue: tokenAmount,
        platformFee,
        conversionRate,
        networkName: selectedNetwork?.networkName,
        userTransactionHash: transactionHash,
        sapValueInUsd,
        tokenUSDPriceValue,
        platformFeePercentage: selectedNetwork?.platformFee,
      });
      if (res?.status === 200) {
        navigate("/wallet/success", { state: { message: res?.message } });
        setAmount("");
        setTokenAmount("");
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log("dharmik", error)
      console.log(error);
    }
    setBtnLoading(false);
    setOpenQrModal(false);
    setHashValue("");
  };

  useEffect(() => {
    try {
      if (selectedNetwork?.networkName !== "POL") {
        switchNetwork(mainnet);
      } else {
        switchNetwork(polygon);
      }
    } catch (error) {
      console.error("Error switching network:", error);
    }
  }, [address]);

  return (
    <>
      <QrGenerate
        openQrModal={openQrModal}
        setOpenQrModal={setOpenQrModal}
        amount={Number(amount) + Number(platformFee)}
        hashValue={hashValue}
        setHashValue={setHashValue}
        networkName={selectedNetwork?.networkName}
        setLoading={setLoading}
        walletAddress={selectedNetwork?.receiverAddress}
        handleBuyToken={handleBuyToken}
        btnLoading={btnLoading}
        setBtnLoading={setBtnLoading}
      />
      <div
        className={`${
          themeColor === "dark"
            ? "wallet-box wallet-box-content-dark"
            : "wallet-box wallet-box-content"
        }`}
      >
        <div className="wallet-box-cont pruchase-main">
          <div className="logo-box">
            <img src={PagesIndex.Png.logo2} alt="" />
            <div className="logo-title">EPISAP</div>
          </div>
          <div className="wallet-middle-div">
            <div className="purchase-row-header">
              <div className="purchase-first-text-div custom-purchase-div">
                <p>
                  Currently you are {!address && "not"} connected on wallet.{" "}
                  {address && "You will receive SAP token on this wallet"}
                  <div className="wallet-btn-div">
                    <button
                      className="wallet-btn meta-wallet-btn"
                      onClick={() => open()}
                    >
                      {address
                        ? `${address.substring(0, 6)}....${address.substring(
                            address.length - 4
                          )}`
                        : "Connect Wallet"}
                    </button>
                  </div>
                </p>
              </div>
            </div>

            <div className="pruchase-row">
              <div className="purchase-amount-div purchase-input-box">
                <p className="amount-title">Amount</p>
                <input
                  className="input"
                  value={amount}
                  onChange={handleAmountChange}
                  placeholder="Enter Amount"
                />
                {console.log(
                  "selectedNetwork?.networkName",
                  selectedNetwork?.networkName
                )}
                <div className="network-dropdown-div">
                  <select
                    id="token-select"
                    className="dropdown"
                    value={selectedNetwork?.networkName || ""}
                    onChange={handleNetworkChange}
                  >
                    <option value="" disabled>
                      Select Network
                    </option>

                    {networkData?.map((item, index) => (
                      <option key={index} value={item?.networkName}>
                        {item?.networkName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="purchase-token-div purchase-input-box">
                <p className="amount-title">SAP Token</p>
                <input
                  className="input"
                  value={tokenAmount}
                  placeholder="Episap Token"
                />
              </div>
              <div className="purchase-token-div purchase-input-box">
                <p className="amount-title">
                  Platform Fee ({selectedNetwork?.platformFee}%)(
                  {selectedNetwork?.networkName})
                </p>
                <input
                  className="input"
                  value={
                    Number(
                      (Number(amount) * selectedNetwork?.platformFee) / 100 || 0
                    )
                      ?.toFixed(6)
                      .replace(/\.?0+$/, "") || ""
                  }
                  placeholder="Platform Fee"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="total-amount-text-div">
          {Number(amount) > 0 && (
            <p>
              You have to total pay{" "}
              {(
                Number(amount) +
                (Number(amount) * Number(selectedNetwork?.platformFee)) / 100
              )
                .toFixed(6)
                .replace(/\.?0+$/, "")}{" "}
              {selectedNetwork?.networkName}
            </p>
          )}

          {loading ? (
            <p>Do Not Press back button until you finish the whole process!</p>
          ) : (
            ""
          )}
          <button
            onClick={buyToken}
            // className="wallet-btn"
            className={`${
              Number(amount) <= 0
                ? "wallet-btn wallet-btn-disabled"
                : "wallet-btn"
            }`}
            disabled={loading || Number(amount) <= 0}
          >
            {loading ? <CircularProgress size={20} color="inherit" /> : "Buy"}
          </button>
        </div>
      </div>
      {isVisible && (
        <div className="wallet-loader">
          <WalletLoader />
        </div>
      )}
    </>
  );
}
